<template>
  <ul class="verti-timeline list-unstyled">
    <li class="event-list" v-for="item in items" :key="item.createDate">
      <div class="event-timeline-dot">
        <i class="far fa-arrow-alt-circle-left"></i>
      </div>
      <div class="media">
        <div class="media-body">
          <div>
            <span>{{ TellMeWhen(item.createDate) }}</span>
          </div>
          <div>
            <WorkflowDetail :items="item.historyDetailsDto" />
          </div>
        </div>
      </div>
    </li>
  </ul>
</template>

<script>
import WorkflowDetail from './historyActivity/WorkflowDetail.vue'
export default {
  name: 'workflow-history-timeline',
  props: {
    items: {
      type: Array,
    },
  },
  components: {
    WorkflowDetail,
  },
  
}
</script>

<style scoped lang='scss'>
.verti-timeline {
  border-left: 3px dashed #f6f6f6;
  margin: 0 10px;
  .event-list {
    position: relative;
    padding: 0px 0px 40px 30px;
    .event-timeline-dot {
      position: absolute;
      left: -9px;
      top: 0px;
      z-index: 9;
      font-size: 16px;
    }
    .event-content {
      position: relative;
      border: 2px solid gray;
      border-radius: 7px;
    }

    &.active {
      .event-timeline-dot {
        color: blue;
      }
    }

    &:last-child {
      padding-bottom: 0px;
    }
  }
}

.verti-timeline {
  border-left: 0;
  border-right: 3px dashed #f6f6f6;
  .event-list {
    padding: 0 15px 10px 0;
    .event-timeline-dot {
      left: auto;
      right: -9px;
    }
  }
}
</style>